import { useLocation } from "react-router-dom";
import SettingsModal from "../../Blocks/Modals/SettingsModal/SettingsModal";
import {
  enumPlanSettings,
  PlanSettingsSectionNames,
  PlanSettingsSectionRoutes
} from "../../../providers/NavigationProvider";
import { getCurrentSectionData, getRouteToNextTab } from "../_utils";
import * as StateLib from "@/Utils/StateLib";
import Header from "@/appComponents/Navigation/Header/Header";
import cx from "classnames";
import { appstr } from "@coreapp/utils/appstr";
import { useCallback, useEffect } from "react";
import { PlanSettings } from "@/appComponents/Blocks/Modals/SettingsModal/PlanSettings/PlanSettings";
import { usePermissionCheck } from "@/hooks/usePermissionCheck";
import { usePlanSettingsContext } from "@/providers/PlanSettingsProvider";

const PlanSettingsPage = () => {
  const { loadChartMetadata, launchPlanSettings, getMockWsMgr } = usePlanSettingsContext();
  const location = useLocation();
  const { isAdmin } = usePermissionCheck();

  const [, , , baseChartId, sectionRoute] = location.pathname.split("/");
  const { sectionKey, tabIndex } = getCurrentSectionData(
    sectionRoute,
    "General",
    PlanSettingsSectionRoutes,
    enumPlanSettings
  );

  const launchPlanSettingsTab = useCallback(
    (chartID, tab, wsMgr) => {
      if (!wsMgr) {
        return;
      }
      launchPlanSettings(chartID, tab, { replace: true });
      wsMgr.UpdateDocTitle();
    },
    [launchPlanSettings]
  );

  const handleChangeCurrentTab = nextTab => {
    const route = getRouteToNextTab(nextTab, enumPlanSettings, PlanSettingsSectionRoutes);
    launchPlanSettingsTab(baseChartId, route, getMockWsMgr());
  };

  // Redirect to General tab with currently open base chart selected on initial load
  useEffect(() => {
    if (baseChartId) {
      return;
    }
    // Refer original doc on initial load
    const doc = StateLib.GetDoc();
    const targetChartId = doc?.GetChartID();

    if (!targetChartId) {
      return;
    }
    launchPlanSettingsTab(targetChartId, PlanSettingsSectionRoutes.General, StateLib.GetWSMgr());
  }, [baseChartId, launchPlanSettingsTab]);

  useEffect(() => {
    if (!isAdmin || !baseChartId) {
      return;
    }
    loadChartMetadata(baseChartId);
  }, [isAdmin, baseChartId, loadChartMetadata]);

  if (!isAdmin) {
    return null;
  }

  return (
    <div className={cx("appHeader--modal")}>
      <Header customToolbarClass={"oc-settings-toolbar"} />
      <SettingsModal
        title={appstr("Plan settings")}
        subtitle={appstr(PlanSettingsSectionNames[sectionKey])}
        subText={appstr("Plan settings apply to plans created from the selected base chart.")}
      >
        {({ onCloseModal }) => (
          <PlanSettings
            sectionKey={sectionKey}
            currentTab={tabIndex}
            setCurrentTab={handleChangeCurrentTab}
            onCloseModal={onCloseModal}
          />
        )}
      </SettingsModal>
    </div>
  );
};

export default PlanSettingsPage;
